import { render, staticRenderFns } from "./CModalHeader.vue?vue&type=template&id=09827f72&"
import script from "./CModalHeader.vue?vue&type=script&lang=js&"
export * from "./CModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports